module.exports = __webpack_public_path__ + "img/23-avatar male.afb9fbb6.png";